import React, { useEffect } from "react";
import text from "strings/text";
import filter from "./duck/filter";
import presenter from "./duck/presenter";
import { Mixpanel } from "helpers/Mixpanel";

export function UserRoleComponent({
  locationId,
  removeRoleFromUserDispatch,
  addRoleToUserDispatch,
  loadLocationRolesDispatch,
  userPrivilege,
  roles
}) {
  const selectRole = (role) => {
    Mixpanel.track('Add role to user', {
      role_id: role.id,
      role_name: role.name,
      user_id: userPrivilege.userPrivilege.owner_id,
    });
    addRoleToUserDispatch(
      userPrivilege.userPrivilege.owner_id,
      role.id,
      userPrivilege.userPrivilege.user?.tag_ids || [],
      locationId,
      userPrivilege.userPrivilege.id
    );
  };

  const deleteRole = (role) => {
    Mixpanel.track('Remove role from user', {
      role_id: role.id,
      role_name: role.name,
      user_id: userPrivilege.userPrivilege.owner_id,
    });
    removeRoleFromUserDispatch(
      userPrivilege.userPrivilege.owner_id,
      role.id,
      userPrivilege.userPrivilege.user?.tag_ids || [],
      locationId,
      userPrivilege.userPrivilege.id
    );
  };

  const roleRow = (role) => (
    <li className='dropdown-li' key={role.id} onClick={() => selectRole(role)}>
      <div className="role-option-content">
        <span className="role-color-dot" style={{ backgroundColor: `#${role.color_code || '0A84FF'}` }} />
        <label>{role.name}</label>
      </div>
    </li>
  );

  const editRoleRow = (role) => (
    <div className="edit-group-item" key={'edit-' + role.id}>
        <div className="role-option-content">
          <span className="role-color-dot" style={{ backgroundColor: `#${role.color_code || '0A84FF'}` }} />
          <label>{role.name}</label>
        </div>
      <button className="remove-role" onClick={() => deleteRole(role)}>
        <img src="/icons/delete-corner.svg" alt="Remove" />
      </button>
    </div>
  );

  useEffect(() => {
    loadLocationRolesDispatch(locationId);
  }, []);

  console.log('userPrivilege', JSON.stringify(userPrivilege));

  const userRoles = filter.rolesForUser(roles, userPrivilege);
  const otherRoles = filter.otherRolesUserIsNotPartOf(roles, userPrivilege);

  return (
    <div className="user-group">
      <label className="section-label">{text.roles}</label>
      <label className="section-explain">{text.roleExplain}</label>
      <div className="user-group-list">
        {userRoles.map(editRoleRow)}
      </div>
      <div>
        <button
          disabled={otherRoles.length === 0}
          id='other-role-list'
          className="blue-btn"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {text.addNewRole}
        </button>
        <ul className="dropdown-menu" aria-labelledby={'other-role-list'}>
          {otherRoles.map(role => roleRow(role))}
        </ul>
      </div>
    </div>
  );
}

export default UserRoleComponent;
